<template>
	<v-card class="elevation-0 attendees-page attendees-page-container page">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<div class="d-flex">
				<v-skeleton-loader
					v-if="isLoading"
					v-bind="attrs"
					width="600"
					type="list-item, list-item-three-line, card-heading"
				>
				</v-skeleton-loader>

				<div v-else style="width: 100%">
					<div class="attendees-page__title">Attendees</div>

					<div class="events-page__wrap">
						<FilterChipButton
							:isButtonActive="isButtonActive"
							:chipsList="chipsList"
							:clearFilter="clearFilter"
							@handleChipClick="handleChipClick"
						/>

						<div v-if="filterModalIsVisible">
							<FilterModal
								:filterModalIsVisible="filterModalIsVisible"
								:currentModalFilter="currentModalFilter"
								:currentModalLabel="currentModalLabel"
								:selectedChips="selectedChips"
								:filters="filters"
								:dateError="date.error"
								:dateOption="date.option"
								:dateRange="date.selectedRange"
								@closeModal="closeModal"
								@applySelection="applySelection"
								@setItem="setItem"
							/>
						</div>
					</div>

					<div v-for="(attend, index) in attendees" :key="index">
						<AttendCard :user="attend" :event="event" />
					</div>
					<!--					<div
											class="d-flex my-9 justify-center home-page__pagination"
											v-if="!isLoading && attendees.length <= 0"
										>
											<NewsFeedEmpty
												title="Attendees not found at this moment."
												description="Check back later."
												centering="center"
											/>
										</div>-->

					<div
						class="d-flex my-9 justify-center home-page__pagination"
						v-if="!isLoading && attendees.length > 0"
					>
						<Pagination
							:page="filters.page"
							:pageCount="+this.pageCountAttendees"
							v-on:pageChange="onPageChange"
						/>
					</div>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AttendCard from '@/components/Event/AttendCard'
import Pagination from '@/components/Pagination.vue'
import PageBlocked from '@/components/PageBlocked'

import Block from '@/mixins/Block.js'
import Dwh from '@/mixins/Dwh'
import Filter from '@/mixins/Filter'
import FilterModal from '@/components/Modals/FilterModal.vue'
import FilterChipButton from '@/components/FilterChipButtons.vue'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty.vue'

export default {
	name: 'AttendeesPage',
	mixins: [Block, Dwh, Filter],
	components: {
		NewsFeedEmpty,
		FilterChipButton,
		FilterModal,
		AttendCard,
		Pagination,
		PageBlocked,
	},
	methods: {
		...mapActions('event', ['getAttendeesEvent']),
	},

	created() {
		if (this.eventSettings && this.eventSettings.show_attendees) {
			if (this.$route.params.id !== undefined) {
				this.getAttendeesEvent(this.requestQuery)
			}
		} else {
			this.$router.push('/')
		}
		this.sendTrigger({
			category: 'Content',
			action: 'view_attendees_list_event',
			module: 'Events',
			data: this.$route.params.id,
			content_chapter_id:
				this.event && this.event.chapter_id ? [this.event.chapter_id] : null,
		})
	},

	computed: {
		...mapGetters('event', ['isLoading', 'pageCountAttendees', 'attendees', 'event']),
		...mapGetters('settings', ['eventSettings']),
	},

	data() {
		return {
			attrs: {
				elevation: 0,
			},
			filters: {
				page: 1,
			},
			pageBlockedName: 'events',
		}
	},
}
</script>

<style lang="scss">
.attendees-page {
	background: #f1f1f1 !important;
	max-width: 600px;
	width: 100%;

	&__title {
		color: rgb(74, 74, 74);
		font-size: 18px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		margin-bottom: 10px;
	}
}
</style>
